import type { AlertaFacturacion } from "../../lib/consola-api";

/**
 * Qué se puede hacer sobre una alerta, según su estado y quién mira
 * (ADR 0099 B2, C4). El worker revalida todo: esto solo evita ofrecer un botón
 * que el back va a rechazar.
 */

export type AccionDeCola = "tomar" | "facturar" | "no_facturable" | "reabrir";

export interface QuienMira {
  /** `facturacion.write`: tomar, facturar y «no se factura» desde la cola. */
  readonly escribir: boolean;
  /** `produccion.asignar` o `produccion.flexible_transition`: reabrir (C4). */
  readonly decidir: boolean;
}

export function accionesDeLaCola(
  estado: AlertaFacturacion["estado"],
  quien: QuienMira,
): AccionDeCola[] {
  if (estado === "pendiente" && quien.escribir) return ["tomar", "facturar", "no_facturable"];
  if (estado === "en_proceso" && quien.escribir) return ["facturar", "no_facturable"];
  if (estado === "no_facturable" && quien.decidir) return ["reabrir"];
  return [];
}

export type AccionDeOt = "revertir" | "reabrir";

/** Lo que se ofrece en la sección «Facturación» del detalle de la OT (ADR 0099 B3, C4). */
export function accionesDeLaOt(
  estado: AlertaFacturacion["estado"],
  quien: { readonly revertir: boolean; readonly decidir: boolean },
): AccionDeOt[] {
  if (estado === "facturado" && quien.revertir) return ["revertir"];
  if (estado === "no_facturable" && quien.decidir) return ["reabrir"];
  return [];
}

export const MOTIVO_MIN = 10;
export const MOTIVO_MAX = 500;

/** El mismo largo que exige el worker: 10 a 500 caracteres, recortado. */
export function motivoListo(motivo: string): boolean {
  const largo = [...motivo.trim()].length;
  return largo >= MOTIVO_MIN && largo <= MOTIVO_MAX;
}

/** El aviso «OT cerrada sin alerta de facturación» lleva las dos decisiones (A4). */
export const esAvisoDeFacturacion = (tipo: string) => tipo === "facturacion_sin_alerta";
